import { useEffect, useState } from "react";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import getDecodedToken from "services/getDecodedToken";
import { PageContainer, DataTable, StatusBadge, Button } from "components/ui";

const IconTrash = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

const MyDemands = () => {
  const axiosPrivate = useAxiosPrivate();
  const [demands, setDemands] = useState([]);
  const [id, setId] = useState();
  const [email, setEmail] = useState("");

  const fetchMyDemands = async () => {
    try {
      const response = await axiosPrivate.get(`/demande/${id}/myDemands`);
      setDemands(response.data);
    } catch (err) {
      console.error("demands not found");
    }
  };
  const fetchUserByEmail = async (email) => {
    try {
      const response = await axiosPrivate.get("/user/getU", { params: { email } });
      setId(response.data.user_id);
    } catch (err) {
      console.error("User not found");
    }
  };
  const deleteDemand = async (id) => {
    try {
      await axiosPrivate.delete(`/demande/${id}`);
      fetchMyDemands();
    } catch (err) {
      console.error("demand not found");
    }
  };
  useEffect(() => {
    const decodedToken = getDecodedToken();
    if (decodedToken) setEmail(decodedToken.sub);
    if (email) fetchUserByEmail(email);
  }, [email]);
  useEffect(() => { if (id) fetchMyDemands(); }, [id]);

  const responseTone = (r) =>
    r === "APPROVED" ? "success" : r === "REJECTED" ? "danger" : "info";

  return (
    <PageContainer>
      <DataTable
        title="My demands"
        subtitle="Requests you've submitted"
        data={demands}
        rowKey={(d, i) => d.demande_id ?? i}
        searchPlaceholder="Search motif…"
        pageSize={10}
        emptyTitle="No demands yet"
        columns={[
          { key: "motif",     header: "Motif",      render: (d) => <strong>{d.motif}</strong> },
          { key: "status",    header: "Status",     render: (d) => <span>{d.status}</span> },
          { key: "response",  header: "Response",   render: (d) => <StatusBadge tone={responseTone(d.response)} dot>{d.response}</StatusBadge> },
          { key: "dateDebut", header: "First date", render: (d) => <span className="t-mono t-muted">{d.dateDebut}</span> },
          { key: "dateFin",   header: "Last date",  render: (d) => <span className="t-mono t-muted">{d.dateFin}</span> },
          {
            key: "actions", header: "", align: "right",
            render: (d) => (
              <Button variant="danger" size="sm" leftIcon={<IconTrash />} onClick={() => deleteDemand(d.demande_id)}>
                Delete
              </Button>
            ),
          },
        ]}
      />
    </PageContainer>
  );
};

export default MyDemands;
